//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormHandler from './mixins/form-handler';

import Btn from '../components/Btn.vue';
import IconArrow from '../components/IconArrow.vue';
import FormField from '../components/FormField.vue';
import FormCheckbox from '../components/FormCheckbox.vue';
import FormFile from '../components/FormFile.vue';

export default {
	name: 'Vacancy',

	components: { Btn: Btn, IconArrow: IconArrow, FormField: FormField, FormCheckbox: FormCheckbox, FormFile: FormFile },
	mixins: [FormHandler],

	props: {
		target: {
			type: Object,
			required: true
		},

		form: {
			type: Object,
			required: true
		},

		clear: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			content: {}
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Vacancy.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/Vacancy.vue
// module chunks = 0